import { render } from "./vpaymoneypostgoods.vue?vue&type=template&id=059dc49a&scoped=true"
import script from "./vpaymoneypostgoods.vue?vue&type=script&lang=js"
export * from "./vpaymoneypostgoods.vue?vue&type=script&lang=js"

import "./vpaymoneypostgoods.vue?vue&type=style&index=0&id=059dc49a&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/生产环境租户后台rent.syinba.com/jsvueweb/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-059dc49a"]])

export default __exports__